import { CraftsmanCostCalcOutput, isDefined } from '@aloft/toolkit-shared';

export const costOutputToCostPerUnitString = (
  costOutput: CraftsmanCostCalcOutput,
  showUnit = true,
  deprecationRatio?: number,
) => {
  if (costOutput === undefined) {
    return undefined;
  }

  const { variable, unit } = costOutput;

  if (!variable) return undefined;

  let val = variable;

  if (deprecationRatio) {
    val = val.mul(1 - deprecationRatio);
  }

  return `${val.toString()}${isDefined(unit) && showUnit && unit !== 'unit' ? ` / ${unit}` : ''}`;
};
